/* eslint-disable no-nested-ternary */
import React from 'react';
import { Box, IconButton } from '@mui/material';
import { useRouter } from 'next/router';

import { PermissionsGate, TaskStages, FAReloadIcon } from '@components';
import { NoAccess, Loader } from 'components/common/ui';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import taskLayoutStyles from './taskLayout.style';

const TaskLayout = ({
  renderHeaderOptions,
  children,
  entity,
  task,
  url,
  isLoading,
  disabled = false,
  stages,
  boards,
  currentBoard,
  currentStage,
  styles = {},
  onReload,
  onChangeStage,
  onChangeBoard,
  wrapperStyles = {},
}) => {
  const router = useRouter();

  const handleBackButton = () => {
    if (url) {
      router.push(url);
    } else {
      router.back();
    }
  };

  return (
    <PermissionsGate entity={entity} RenderError={NoAccess}>
      {isLoading ? (
        <Loader />
      ) : (
        <Box sx={{ ...taskLayoutStyles.wrapper, ...wrapperStyles }}>
          <Box sx={{ ...taskLayoutStyles.innerWrapper, ...styles }}>
            <Box sx={taskLayoutStyles.header}>
              <Box sx={taskLayoutStyles.headerInner}>
                <Box sx={taskLayoutStyles.breadcrump}>
                  <IconButton
                    onClick={handleBackButton}
                    sx={taskLayoutStyles.backBtn}
                  >
                    <ArrowBackIosIcon
                      data-testid="ArrowBackIosIcon"
                      sx={taskLayoutStyles.icon}
                    />
                  </IconButton>
                  <Box sx={taskLayoutStyles.task}>
                    {task} {onReload && <FAReloadIcon onClick={onReload} />}
                  </Box>
                </Box>
                <Box>{renderHeaderOptions?.()}</Box>
              </Box>
              {stages && (
                <TaskStages
                  stages={stages}
                  boards={boards}
                  currentStage={currentStage}
                  currentBoard={currentBoard}
                  disabled={disabled}
                  onChange={onChangeStage}
                  onChangeBoard={onChangeBoard}
                />
              )}
            </Box>

            <Box sx={taskLayoutStyles.content}>{children}</Box>
          </Box>
        </Box>
      )}
    </PermissionsGate>
  );
};

export default TaskLayout;
